import { SimplePageLayout } from '@lmc/ui-kit'
import AccessControl from 'components/AccessControl/AccessControl'
import { Features } from 'components/AccessControl/useFeatures'
import { lazy } from 'react'
import { Route } from 'react-router-dom'
import GoalsComingSoon from 'screens/Residents/screens/ResidentsGoalsScreen/components/GoalsComingSoon/GoalsComingSoon'
import GoalsScreen from 'screens/Residents/screens/ResidentsGoalsScreen/GoalsScreen'
import LazyLoad from '../LazyLoad'
import { ID } from '../utils'

const AddGoalScreen = lazy(
  () =>
    import(
      'screens/Residents/screens/ResidentsGoalsScreen/components/AddGoalScreen/AddGoalScreen'
    )
)
const EditGoalScreen = lazy(
  () =>
    import(
      'screens/Residents/screens/ResidentsGoalsScreen/components/EditGoalScreen/EditGoalScreen'
    )
)
const ViewGoalScreen = lazy(
  () =>
    import(
      'screens/Residents/screens/ResidentsGoalsScreen/components/ViewGoalScreen/ViewGoalScreen'
    )
)

const GOALS_URL = `goals`
const GOAL_ID = 'goalID'
const CREATE = 'create'
const EDIT = 'edit'
const COMING_SOON = 'coming-soon'

export const GOALS = {
  INDEX: `/residents/${ID}/${GOALS_URL}`,
  VIEW: `/residents/${ID}/${GOALS_URL}/:${GOAL_ID}`,
  EDIT: `/residents/${ID}/${GOALS_URL}/:${GOAL_ID}/${EDIT}`,
  CREATE: `/residents/${ID}/${GOALS_URL}/${CREATE}`,
  COMING_SOON: `/residents/${ID}/${GOALS_URL}/${COMING_SOON}`,
  MANAGEMENT: '/reports/goals/goals-management'
}

export const goalsRoutes = (
  <Route
    path={`${ID}/${GOALS_URL}`}
    element={
      <AccessControl features={[Features.GOALS]}>
        <SimplePageLayout />
      </AccessControl>
    }
  >
    <Route element={<GoalsScreen />} index />
    <Route element={<GoalsComingSoon />} path={COMING_SOON} />
    <Route
      path={CREATE}
      element={
        <LazyLoad>
          <AddGoalScreen />
        </LazyLoad>
      }
    />
    <Route path={`:${GOAL_ID}`}>
      <Route
        index
        element={
          <LazyLoad>
            <ViewGoalScreen />
          </LazyLoad>
        }
      />
      <Route
        path={EDIT}
        element={
          <LazyLoad>
            <EditGoalScreen />
          </LazyLoad>
        }
      />
    </Route>
  </Route>
)

export default goalsRoutes
